// Loaded at the masthead to preserve the existing initialization order.
// Sticky title bar + reading progress.
// Shows the bar when the masthead leaves the viewport;
// fills the progress line as the user scrolls through the article body.
(() => {
  const masthead = document.querySelector('[data-article-masthead]');
  const stickybar = document.querySelector('[data-reading-progress]');
  const progressFill = document.querySelector('[data-reading-progress-fill]');
  if (!masthead || !stickybar) return;

  // The bar sits below the wls-navbar on desktop, but pins to the viewport
  // top on mobile (matches the breakpoint in _user.scss).
  const mobileQuery = window.matchMedia('(max-width: 767.98px)');
  const getStickyOffset = () => (mobileQuery.matches ? 0 : 86);

  // Show/hide the sticky bar based on whether the masthead is in view
  let visibilityObserver;
  const observeVisibility = () => {
    if (visibilityObserver) visibilityObserver.disconnect();
    const offset = getStickyOffset();
    visibilityObserver = new IntersectionObserver(
      (entries) => {
        const visible = !entries[0].isIntersecting;
        stickybar.classList.toggle('is-visible', visible);
        stickybar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      },
      { rootMargin: `-${offset}px 0px 0px 0px`, threshold: 0 }
    );
    visibilityObserver.observe(masthead);
  };
  observeVisibility();
  mobileQuery.addEventListener('change', observeVisibility);

  // Reading progress — recomputed on scroll, throttled with rAF
  const article = document.querySelector('[data-article-body]');
  if (article && progressFill) {
    let ticking = false;
    const updateProgress = () => {
      const offset = getStickyOffset();
      const rect = article.getBoundingClientRect();
      const total = rect.height - window.innerHeight + offset;
      const scrolled = -rect.top + offset;
      const pct = total > 0 ? Math.max(0, Math.min(1, scrolled / total)) : 0;
      progressFill.style.transform = `scaleX(${pct})`;
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateProgress);
        }
      },
      { passive: true }
    );
    updateProgress();
  }
})();
